module.exports = __webpack_public_path__ + "img/building.53a8cbf2.svg";